<template>
  <div class="container">
    <Breadcrumb :path="path"></Breadcrumb>
    <div class="tips">
      {{ tips }}
    </div>
    <!-- 表单 -->
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="主题" required prop="theme">
        <a-input v-model="form.theme" placeholder="请输入主题" />
      </a-form-model-item>

      <van-field name="radio" label="反馈方式" disabled prop="FeedMode">
        <template #input>
          <van-radio-group v-model="form.FeedMode" direction="horizontal">
            <van-radio checked-color="#ee0a24" icon-size="22px" name="1"
              >实名</van-radio
            >
          </van-radio-group>
        </template>
      </van-field>
      <a-form-model-item label="申请人" required prop="applicant">
        <a-input v-model="form.applicant" disabled placeholder="请输入申请人" />
      </a-form-model-item>
      <a-form-model-item label="联系方式" required prop="ContactInfo">
        <a-input
          v-model="form.ContactInfo"
          disabled
          placeholder="请输入联系方式"
        />
      </a-form-model-item>
      <a-form-model-item label="表扬对象" required prop="ObjectPraise">
        <a-input
          v-model="form.ObjectPraise"
          type="textarea"
          style="resize: none; word-break: break-all"
          class="jysy"
        />
      </a-form-model-item>
      <a-form-model-item label="具体案例" required prop="SpecificCase">
        <a-input
          v-model="form.SpecificCase"
          type="textarea"
          style="resize: none; word-break: break-all"
          class="gsjy"
        />
      </a-form-model-item>
      <div class="upload"><span>附件</span> 文件大小限制30M以内</div>

      <div class="fileName" v-if="fileInfo">
        <div class="left">
          <div class="top">{{ fileInfo.name }}</div>
          <div class="bottom">{{ fileInfo.size }}k</div>
        </div>
        <div class="right" @click="deleteFile">删除</div>
      </div>

      <div class="fileUpload">
        <van-uploader
          :max-size="30000 * 1024"
          v-model="fileList"
          multiple
          :after-read="afterRead"
          upload-icon="plus"
          accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf, image/jpeg, image/png, text/plain"
          @delete="deleteFiles"
        />
      </div>

      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button type="primary" @click="onSubmit" :loading="btnLoading">
          提交
        </a-button>
        <a-button class="min767" style="margin-left: 10px" @click="Cancel">
          取消
        </a-button>
      </a-form-model-item>
    </a-form-model>
    <!-- 表单END -->

    <van-popup class="popup" v-model="show" :close-on-click-overlay="false">
      <img src="../../assets/img/success.png" alt="" />
      <div class="title">提交成功</div>
      <div class="titleInf">
        我们将尽快为您处理，结果将以短信通知您，请留意查看！
      </div>
    </van-popup>
  </div>
</template>
   
<script>
import {
  $add_commend,
  $upload,
  $get_user_info,
  $data_type_des,
  $get_type,
} from "@/api/index.js";
import { Message } from "ant-design-vue";
import Breadcrumb from "../../components/Breadcrumb";
import lodash from "lodash";
export default {
  name: "commend",
  components: {
    Breadcrumb,
  },
  data() {
    // 手机号验证规则
    let checkPhone = (rules, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        let phoneZZ =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!phoneZZ.test(value)) {
          callback(new Error("请输入正确的手机号格式"));
        } else {
          callback();
        }
      }
    };
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      btnLoading: false,
      show: false,
      imageUrl: "",
      fileList: [],
      fileInfo: "",
      tips: "",
      typeList: "",
      fileListData: [],
      form: {
        theme: "", // 主题
        FeedMode: "1", // 反馈方式
        applicant: "", // 申请人
        ContactInfo: "", // 联系方式
        ObjectPraise: "", // 表扬对象
        SpecificCase: "", // 具体案例
      },
      rules: {
        theme: [
          { required: true, message: "请输入主题", trigger: "change" },
          { min: 2, message: "内容不能低于2个字", trigger: "blur" },
        ],
        FeedMode: [
          { required: true, message: "请选择反馈方式", trigger: "change" },
        ],
        applicant: [
          { required: true, message: "请填写申请人", trigger: "change" },
        ],
        ContactInfo: [{ validator: checkPhone, trigger: "change" }],

        ObjectPraise: [
          { required: true, message: "请填写表扬对象", trigger: "change" },
        ],
        SpecificCase: [
          { required: true, message: "请填写具体案例", trigger: "change" },
          { min: 10, message: "内容不能低于10个字", trigger: "blur" },
        ],
      },
    };
  },
  async mounted() {
    try {
      let { data: userinfo } = await $get_user_info();
      this.form.applicant = userinfo.real_name;
      this.form.ContactInfo = userinfo.mobile;
    } catch (error) {}

    try {
      let res = await $data_type_des({ data_type: 3 });

      this.tips = res.data[0];
    } catch (error) {
      console.log(error);
    }

    try {
      let res = await $get_type({ data_type: 3 });
      console.log("get_type", res);
    } catch (error) {
      console.log(error);
    }
  },
  // 计算属性
  computed: {
    // 面包屑
    path() {
      let arr = [
        { name: "首页", names: "Home" },
        { name: "表彰表扬", names: "commend" },
      ];
      return arr;
    },
  },
  // 数据监听
  watch: {},

  methods: {
    // 删除文件
    deleteFile() {
      this.fileInfo = "";
      this.fileList = [];
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      if (file.length > 1) {
        file.forEach((item) => {
          let formData = new FormData();
          formData.append("file", item.file);
          $upload(formData)
            .then((res) => {
              this.fileListData.push({
                filename: item.file.name,
                path: res.data.image,
                file_type: item.file.type,
              });
            })
            .catch((err) => {
              console.log(err);
              // Message.error({ content: '文件上传失败' });
            });
        });
        console.log("this.fileListData", this.fileListData);
        return;
      }
      let formData = new FormData();
      formData.append("file", file.file);
      $upload(formData)
        .then((res) => {
          this.fileListData.push({
            filename: file.file.name,
            path: res.data.image,
            file_type: file.file.type,
          });
        })
        .catch((err) => {
          // Message.error({ content: '文件上传失败' });
        });
      console.log("this.fileListData", this.fileListData);
    },
    deleteFiles(file, detail) {
      this.fileListData.splice(detail.index, 1);
    },
    // theme: '',  // 主题
    // FeedMode: '1', // 反馈方式
    // applicant: '', // 申请人
    // ContactInfo: '', // 联系方式
    // ObjectPraise: '', // 表扬对象
    // SpecificCase: "", // 具体案例
    // 提交按钮
    onSubmit: lodash.throttle(function () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.btnLoading = true;
          try {
            let params = {
              title: this.form.theme,
              type: this.form.SuggestedType,
              // feedback_type: this.form.FeedMode,
              real_name: this.form.applicant,
              mobile: this.form.ContactInfo,
              commend_obj: this.form.ObjectPraise,
              commend_case: this.form.SpecificCase,
              files: this.fileListData,
              // for_complaint: this.form.HandlingSuggestion,
            };
            let res = await $add_commend(params);
            setTimeout(() => {
              this.show = true;
              this.$router.push({ name: "feedback" });
              this.btnLoading = false;
            }, 3000);
            this.show = true;
            this.$refs.form.resetFields();
            this.form.SuggestedType = "";
            this.form.FeedMode = "";
            this.fileList = [];
          } catch (error) {
            console.log(error);
          } finally {
            // this.btnLoading = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }, 60000),
    // 取消
    Cancel() {
      this.$router.back();
    },
    // 弹出层，返回首页
    backHome() {
      this.$router.push("/home");
      this.show = false;
    },
  },
};
</script>
   
<style scoped lang="less">
@media (min-width: 767px) {
  .container {
    max-width: 1280px;
    height: auto;
    background: #ffffff;
    margin: 16px auto;
    padding: 26px 86px;

    .tips {
      width: 100%;
      height: auto;
      background: #f5f5f5;
      margin-top: 23px;
      margin-bottom: 35px;
      padding: 23px 34px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
    }

    /deep/.ant-form-item {
      margin-bottom: 20px;
    }

    // 每一项表单标题
    /deep/.ant-form-item-required {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    /deep/.ant-input {
      font-size: 18px;
    }

    /deep/.van-field__label {
      position: relative;
      margin-left: -6px;
      margin-right: 0px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    /deep/.van-field__label::before {
      content: "*";
      position: absolute;
      color: red;
      top: 0;
      left: -10px;
      font-family: SimSun, sans-serif;
      font-size: 14px;
    }

    /deep/.van-field__label::after {
      content: ":";
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 18px;
      font-family: PingFang SC;
    }

    /deep/.van-radio__label {
      font-size: 18px;
    }

    /deep/.van-cell {
      position: unset;
      padding-top: 0px;
      margin-bottom: 8px;
    }

    .jysy,
    .gsjy,
    .yqxg {
      height: 90px;
    }

    .fileName {
      margin-left: 98px;
      margin-top: 20px;
      margin-bottom: 29px;
      display: flex;
      align-items: center;
      flex-direction: row;

      .left {
        margin-right: 35px;

        .top {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
        }

        .bottom {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
        }
      }

      .right {
        width: 91px;
        height: 41px;
        background: #ffeaec;
        border-radius: 4px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #e60012;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }
    }

    .line {
      width: 91%;
      height: 1px;
      background-color: #cfcfcf;
      margin: 7px auto;
      // margin-left: 95px;
      // margin-bottom: 15px;
      // border: 1px solid #CFCFCF;
    }

    .upload {
      padding-left: 53px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;

      span {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
      }
    }

    /deep/.ant-col-4 {
      width: 98px;
    }

    /deep/.ant-col-14 {
      width: 90.333333%;
    }

    // 文件上传

    .fileUpload {
      margin-left: 98px;
      margin-top: 6px;

      /deep/ .van-uploader__upload {
        background-color: #f6f6f6;
      }
    }
  }

  // 按钮

  /deep/.ant-btn {
    width: 122px;
    height: 49px;
    background: #e1e1e1;
    border-radius: 4px;

    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  /deep/.ant-btn-primary {
    margin-left: -88px;
    margin-top: 30px;
    width: 122px;
    height: 49px;
    background: #e60012;
    border-radius: 4px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    border: none;
  }

  .popup {
    width: 472px;
    height: 301px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .title {
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      margin: 13px 0 8px 0;
    }

    .titleInf {
      padding: 0 57px;
      font-size: 18px;
      font-family: PingFang SC;
      text-align: center;
      font-weight: 500;
      color: #666666;
    }

    .cancel {
      width: 122px;
      height: 49px;
      background: #e60012;
      border-radius: 4px;
      line-height: 49px;
      text-align: center;
      color: #fff;
      margin-top: 33px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      cursor: pointer;
    }
  }
}

// H5样式

@media (max-width: 767px) {
  .container {
    width: 100%;
    height: auto;
    background: #ffffff;
    padding: 16px;

    .tips {
      width: 100%;
      height: auto;
      background: #f5f5f5;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      line-height: 17px;
      padding: 13px 20px 16px 16px;
      margin-bottom: 22px;
    }

    /deep/.ant-form-item-required {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333;
      margin-bottom: 10px;
    }

    /deep/.ant-form-item-label {
      margin-bottom: 10px;
      padding: 0;
    }

    /deep/.ant-input {
      font-size: 15px;
    }

    /deep/.van-field__label {
      position: relative;
      margin-bottom: 10px;
      margin-left: 10px;
      font-size: 18px;
      font-family: PingFang SC;
      color: #333333;
      font-weight: 800;
    }

    /deep/.van-field__label::before {
      content: "*";
      position: absolute;
      color: red;
      top: 0;
      left: -10px;
      font-family: SimSun, sans-serif;
      font-weight: bold;
      font-size: 14px;
    }

    /deep/.van-cell {
      position: unset;
      padding-top: 0px;
      margin-bottom: 8px;
      display: flex;
      flex-direction: column;
      padding: 10px 0;
    }

    /deep/.van-radio__label {
      font-size: 15px;
    }

    .fileName {
      margin-left: 95px;
      margin-top: 20px;
      margin-bottom: 29px;
      display: flex;
      align-items: center;
      flex-direction: row;
      display: none;

      .left {
        margin-right: 35px;

        .top {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
        }

        .bottom {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
        }
      }

      .right {
        width: 91px;
        height: 41px;
        background: #ffeaec;
        border-radius: 4px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #e60012;
        line-height: 40px;
        text-align: center;
      }
    }

    .line {
      width: 91%;
      height: 1px;
      background-color: #cfcfcf;
      margin: 0 auto;
      margin-bottom: 15px;
      // border: 1px solid #CFCFCF;
      display: none;
    }

    .upload {
      // padding-left: 53px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;

      span {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #333333;
      }
    }

    /deep/.ant-col-4 {
      width: 40%;
    }

    /deep/.ant-col-14 {
      width: 100%;
    }

    // 文件上传

    .fileUpload {
      // margin-left: 95px;
      margin-top: 6px;

      /deep/ .van-uploader__upload {
        background-color: #f6f6f6;
      }
    }

    .avatar-uploader > .ant-upload {
      width: 128px;
      height: 128px;
    }

    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }

    /deep/.ant-upload.ant-upload-select-picture-card {
      border: none !important;
    }
  }

  .ant-input {
    height: 37px;
  }

  .jysy,
  .gsjy {
    height: 87px;
  }

  .yqxg {
    height: 104px;
  }

  // 按钮
  /deep/.ant-btn {
    width: 122px;
    height: 49px;
    background: #e1e1e1;
    border-radius: 4px;

    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  /deep/.ant-btn-primary {
    width: 100%;
    height: 49px;
    background: #e60012;
    border-radius: 4px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    border: none;
  }

  /deep/.ant-col-offset-4 {
    margin-left: 0;
  }

  .min767 {
    display: none;
  }

  .popup {
    width: 339px;
    height: 274px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;

    .title {
      font-size: 19px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
    }

    .titleInf {
      width: 278px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      text-align: center;
    }

    .cancel {
      width: 155px;
      height: 51px;
      line-height: 51px;
      text-align: center;
      background: #ea4949;
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #ffffff;
      cursor: pointer;
    }
  }
}
</style>
   